import React from "react";

/**
 * v2.0 #9 — Status segments above list pages.
 * Renders a row of pill buttons (Open / Resolved / Closed / ... / All) with live counts.
 *
 * Props:
 *   value: currently-selected key
 *   onChange(key): when a pill is clicked
 *   items: full dataset (so we can show counts per segment)
 *   segments: [{ key, label, match(item) -> bool }]
 */
export default function StatusSegments({ value, onChange, items = [], segments = [] }) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {segments.map((s) => {
        const count = items.filter(s.match).length;
        const active = value === s.key;
        return (
          <button
            key={s.key}
            type="button"
            onClick={() => onChange(s.key)}
            className={
              "px-3 py-1.5 rounded-full text-sm font-medium transition border " +
              (active
                ? "bg-brand-500 text-white border-brand-500 shadow-sm"
                : "bg-white text-gray-700 border-gray-200 hover:bg-gray-50 hover:border-gray-300")
            }
          >
            {s.label}
            <span
              className={
                "ml-2 px-1.5 py-0.5 rounded-full text-xs " +
                (active ? "bg-white/20" : "bg-gray-100 text-gray-600")
              }
            >
              {count}
            </span>
          </button>
        );
      })}
    </div>
  );
}
